import { Item } from 'types/items';
import * as yup from 'yup';

export const getInitialValues = (item: Item | null) => ({
  sku: item?.sku?._id || '',
  washHub: item?.washHub?._id || '',
  skuId: item?.sku?._id || '',
  size: item?.size || '',
  type: item?.type || '',
  rfid: item?.rfid || '',
  status: item?.status || 0,
  packageId: item?.currentPackage || '',
  venue: item?.currentVenue?.name,
  qrCode: item?.qrCode || '',
});

export const validationSchema = yup.object().shape({
  sku: yup.string().required('SKU is required'),
  washHub: yup.string(),
});
